import React, {useEffect} from 'react';
import {getPostLoginHandle} from "../../services/UserRepository";
import {useNavigate} from "react-router-dom";
import {useAuth} from "react-oidc-context";

export function PostLogin() {

    const navigate = useNavigate();
    const auth = useAuth()

    useEffect(() => {
        getPostLoginHandle(auth.user.id_token).then(() => navigate("/")).catch(error => console.error(error))
    }, []);

    return (
        <div></div>
    );

}